<template>
  <div v-if="model && !model.$disabled" class="row form-group">
    <div class="col-12">
      <p class="label">{{ getTitle }}</p>

      <address-picker :type-terc="true" :model="model" :disabled="checkDisabled('address')" />
    </div>
  </div>
</template>

<script>
import AddressPicker from '@/components/formComponents/AddressPicker';
import { componentMixin } from '@/mixins/document/component';

// @vuese
// School component
// @Group formComponents
export default {
  components: { AddressPicker },
  mixins: [componentMixin]
};
</script>
